import styled, { css, keyframes } from 'styled-components';

const spin = keyframes`
  from {
    transform: rotate(0deg);
  } to {
    transform: rotate(-360deg);
  }
`;

const Icon = styled.i`
  width: 22px;
  height: 22px;
  background-color: ${props => props.theme.colors.elementLine};
  border-radius: 100%;
  display: flex;
  align-items: center;
  margin: auto 1vw;
  img {
    width: 100%;
  }
  ${props =>
    props.showLoading &&
    css`
      img {
        animation-name: ${spin};
        animation-duration: 1000ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
      }
      background-color: inherit;
    `}
`;

export default Icon;
